import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=47fc839b&scoped=true&"
import script from "./collect.vue?vue&type=script&lang=js&"
export * from "./collect.vue?vue&type=script&lang=js&"
import style0 from "./collect.vue?vue&type=style&index=0&lang=less&"
import style1 from "./collect.vue?vue&type=style&index=1&id=47fc839b&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc839b",
  null
  
)

export default component.exports